import { render, staticRenderFns } from "./WsTest.vue?vue&type=template&id=091d67f4&"
import script from "./WsTest.vue?vue&type=script&lang=js&"
export * from "./WsTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports